import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  productList: {
    list: {
      data: [],
      total: 0,
    },
  },
  kittingList: {
    list: {
      data: [],
      total: 0,
    },
  },
  productGroupingList: {
    list: {
      data: [],
      total: 0,
    },
  },
  pwpFocList: {
    list: {
      data: [],
      total: 0,
    },
  },
  productSearchData: {
    list: [],
  },
  saveData: {},
  ProductLessData: {},
  productCategories: {
    list: [],
  },
  kittingQualifiedBaseCVS: {
    data: {
      base_bv: 0,
      base_cv: 0,
      base_sv: 0,
      base_cbp_point: 0,
    },
  },
  kittingStats: {
    data: null,
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
